import styled, { css } from 'styled-components';
var TableWrapper = styled.div.withConfig({
  displayName: "Tablestyles__TableWrapper",
  componentId: "sc-2pmuda-0"
})(["padding:1px;overflow-x:auto;"]);
var Table = styled.table.withConfig({
  displayName: "Tablestyles__Table",
  componentId: "sc-2pmuda-1"
})(["&&{width:100%;table-layout:fixed;text-align:center;font-size:", ";font-weight:", ";line-height:", ";", " ", "}"], function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.font.weight.regular;
}, function (props) {
  return props.theme.font['line-height']['body-1'];
}, function (props) {
  return props.numberOfColumns > 4 && css(["min-width:525px;"]);
}, function (props) {
  return props.wide && css(["min-width:1340px;"]);
});
var sharedCellStyles = css(["padding:0;height:50px;overflow:hidden;vertical-align:middle;word-break:break-word;"]);
var TableHeader = styled.th.withConfig({
  displayName: "Tablestyles__TableHeader",
  componentId: "sc-2pmuda-2"
})(["&&{", ";border:0;font-size:", ";font-weight:", ";background-color:", ";}"], sharedCellStyles, function (props) {
  return props.theme.font.size['body-1'];
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.color.monochrome.white;
});
var TableRow = styled.tr.withConfig({
  displayName: "Tablestyles__TableRow",
  componentId: "sc-2pmuda-3"
})(["&:nth-child(even){background-color:", ";}"], function (props) {
  return props.theme.color.monochrome.lighter;
});
var TableData = styled.td.withConfig({
  displayName: "Tablestyles__TableData",
  componentId: "sc-2pmuda-4"
})(["&&{", ";border:1px solid ", ";line-height:1.25rem;}"], sharedCellStyles, function (props) {
  return props.theme.color.monochrome.light;
});
export { TableWrapper, Table, TableHeader, TableRow, TableData };